import React from 'react'
import { createRoot } from 'react-dom/client'

import { LoadingSpinner } from '../components'
import { lti as endpoints } from '../api_urls'
import { client, convertStringBool } from '../utils'

import ContentItemSelection from './components/ContentItemSelection'
import ContentItemSelectionError from './components/ContentItemSelectionError'

export const startContentItemSelectionApp = (coursenum, acceptMultipleStr) => {
  const root = createRoot(document.getElementById('content-item-selection-app'))
  root.render(
    <div className="text-center lead">
      <LoadingSpinner text="Getting Content Items..." className="icon_3x" />
    </div>
  )
  getGroupData()
    .then(gdObj => {
      const acceptMultiple = convertStringBool(acceptMultipleStr)
      const root = createRoot(document.getElementById('content-item-selection-app'))
      root.render(
        <ContentItemSelection
          acceptMultiple={acceptMultiple}
          groups={gdObj.data.groups}
          chapters={gdObj.data.chapters}
          coursenum={coursenum}
          handleSubmit={postGroupData}
        />
      )
    })
    .catch(error => {
      const root = createRoot(document.getElementById('content-item-selection-app'))
      root.render(<ContentItemSelectionError error={error} />)
    })
}

function getGroupData() {
  const url = endpoints.getItemGroups()
  return client.get(url)
}

async function postGroupData(selectData) {
  try {
    const url = endpoints.postItemGroups()
    const response = await client.post(url, selectData)
    for (let field in response.data) {
      document.getElementsByName(field)[0].value = response.data[field]
    }
    document.getElementById('content-item-selection').submit()
  } catch (err) {
    $.meDialog.topMessage(
      '<p>An error occurred. Please contact MyEducator support if the issue persists.</p>',
      3000,
      'danger'
    )
  }
}
